import LabourForecast from './LabourForecast';

export default LabourForecast;
